// Typing in a search box starts a load per keystroke, so several are in flight at once
// and they do not answer in the order they were sent. A generation counter decides which
// reply is still the one on screen: every load claims the next number, and a reply whose
// number has since been claimed by a newer load is stale — it commits nothing, and the
// caller keeps its loading mask up for the request that is still coming.
//
// Returns the response, or null when a newer load has overtaken this one. Written here
// rather than in each list store; store/admin/users.js grew the shape first (#1569).
export default async({ commit, state }, fetch) => {
  const generation = state.generation + 1;
  commit('GENERATION_SET', generation);

  let response;
  try {
    response = await fetch();
  } catch (error) {
    // A reply the user has already filtered past must not raise an error over the rows
    // they are looking at now.
    if (generation !== state.generation) return null;
    throw error;
  }

  return generation === state.generation ? response : null;
};
